import React from 'react';
import type { Project } from '../../models/projects/project';
import { STATUS } from '../../models/projects/project';

type Props = {
  project: Project;
};

export default function CardRibbon(props: Props) {
  const { project } = props;

  if (project.status === STATUS.executed) {
    return (
      <div className="ribbon executed">
        <div className="title">成約済み</div>
      </div>
    );
  }

  return null;
}
